import { Box } from '@terra/ui-styled-system';

export const TimelineConnector = () => {
  return <Box width="1px" flex="1" bg="border.default" />;
};
